// Mock data for ProClean Mobile Detailing

export const businessInfo = {
  name: "Pro Clean Mobile Detailing",
  tagline: "Professional Care. Brought To You.",
  phone: "0421 619 872",
  instagram: "@proclean_mobiledetailing",
  instagramUrl: "https://instagram.com/proclean_mobiledetailing",
  tiktok: "@proclean_mdetailing",
  tiktokUrl: "https://tiktok.com/@proclean_mdetailing",
  email: "proclean.mobiledetailiing@gmail.com",
  serviceArea: "Sydney, NSW, Australia"
};

export const vehicleSizes = [
  { id: 'small', label: 'Small', description: 'Hatchback, Compact sedan', multiplier: 1.0 },
  { id: 'medium', label: 'Medium', description: 'Sedan, Wagon, Coupe', multiplier: 1.15 },
  { id: 'large', label: 'Large', description: 'SUV, Ute, 4WD', multiplier: 1.35 },
  { id: 'xlarge', label: 'Extra Large', description: '7-Seater, Van, Dual cab', multiplier: 1.55 }
];

export const packages = [
  {
    id: 4,
    name: "Basic Detail",
    description: "A proper freshen up — inside & out.",
    startingPrice: "$200",
    basePrice: 200,
    popular: false,
    priceNote: "Flat rate",
    features: [
      "Exterior Foam Bath & Hand Wash",
      "Wheels Cleaned (Barrels & Fender Liners)",
      "Thorough Interior Vacuum",
      "Leather & Surfaces Wiped Down",
      "Custom Air Freshener Throughout",
      "Tyres Dressed"
    ]
  },
  {
    id: 1,
    name: "Premium Detail",
    description: "The full transformation — inside & out.",
    startingPrice: "From $300",
    basePrice: 300,
    popular: true,
    priceNote: "* Varies by vehicle size & condition",
    features: [
      "Exterior Hand Wash",
      "Wheels & Tyres Cleaned",
      "Deep Interior Vacuum",
      "Wipe Down (Dash, Doors, Trims)",
      "Streak-Free Windows",
      "Tyre Shine",
      "Steam Clean Carpets & Seats",
      "Exterior Iron Decontamination",
      "Leather Clean & Condition",
      "Deep Stain Removal",
      "Odor Removal",
      "Ceramic Sealant"
    ]
  },
  {
    id: 3,
    name: "Pre-Sale Detail",
    description: "The complete sale-ready detail — full interior & exterior, engine bay, one-step paint correction and ceramic sealant.",
    startingPrice: "From $549",
    basePrice: 549,
    popular: false,
    priceNote: "* Varies by vehicle size & condition",
    features: [
      "Exterior Hand Wash",
      "Wheels & Tyres Cleaned",
      "Deep Interior Vacuum",
      "Wipe Down (Dash, Doors, Trims)",
      "Streak-Free Windows",
      "Tyre Shine",
      "Steam Clean Carpets & Seats",
      "Exterior Iron Decontamination",
      "Leather Clean & Condition",
      "Deep Stain Removal",
      "Odor Removal",
      "Ceramic Sealant",
      "Engine Bay Clean",
      "One-Step Paint Correction"
    ]
  },
  {
    id: 2,
    name: "Maintenance Detail",
    description: "Members-only upkeep, unlocked after your Premium Detail.",
    startingPrice: "$150",
    basePrice: 150,
    popular: false,
    locked: true,
    priceNote: "Flat rate • Premium customers only",
    features: [
      "Wipe Down (Doors, Trims & Dashboard)",
      "Deep Interior Vacuum",
      "Wheels & Tyres Cleaned (Spokes & Barrels)",
      "Full Body Wash",
      "Tyre Shine",
      "Steering Wheel Wipe Down (if needed)"
    ]
  }
];

export const addOns = [
  { id: 1, name: "Steam Clean & Extraction", description: "Carpets & Seats — per seat", price: "$30 per seat", priceValue: 30 },
  { id: 2, name: "Engine Bay Clean", description: "Professional engine detailing", price: "$50", priceValue: 50 },
  { id: 3, name: "Headlight Restoration", description: "Crystal clear headlights", price: "$90", priceValue: 90 },
  { id: 4, name: "Leather Clean & Conditioning", description: "Premium leather care", price: "$70", priceValue: 70 },
  { id: 7, name: "Leather Coating", description: "Protects your leather from spills & stains", price: "$249.99", priceValue: 249.99 },
  { id: 8, name: "Ceramic Coating (4–6 Months)", description: "Short-term ceramic protection & gloss", price: "$80", priceValue: 80 },
  { id: 5, name: "Ceramic Coating", description: "Ultimate protection", price: "Quote Only", priceValue: null },
  { id: 6, name: "Exterior Iron Decontamination", description: "Remove embedded contaminants", price: "$40", priceValue: 40 }
];

export const galleryCategories = [
  { id: 'all', name: 'All Work' },
  { id: 'exterior', name: 'Exterior Detail' },
  { id: 'snow-foam', name: 'Snow Foam Wash' },
  { id: 'interior', name: 'Interior Detail' }
];

export const galleryImages = [
  {
    id: 1,
    url: "/images/gallery1.jpg",
    alt: "Brabus G-Wagen - Premium Exterior Detail",
    category: "exterior"
  },
  {
    id: 4,
    url: "/images/gallery4.jpg",
    alt: "Mercedes-AMG GT 63 S - Matte Finish Detail",
    category: "exterior"
  },
  {
    id: 3,
    url: "/images/gallery3.jpg",
    alt: "BMW - Snow Foam Wash",
    category: "snow-foam"
  },
  {
    id: 5,
    url: "/images/gallery5.jpg",
    alt: "Ford Ranger Raptor - Pressure Wash",
    category: "snow-foam"
  },
  {
    id: 6,
    url: "/images/gallery6.jpg",
    alt: "Range Rover - Exterior Wash",
    category: "snow-foam"
  },
  {
    id: 2,
    url: "/images/gallery2.jpg",
    alt: "Hyundai Tucson - Interior Detailing",
    category: "interior"
  },
  {
    id: 7,
    url: "/images/gallery7.jpg",
    alt: "Land Rover - Trunk & Interior Vacuum",
    category: "interior"
  },
  {
    id: 8,
    url: "/images/gallery8.jpg",
    alt: "Brabus G-Wagen - Custom Turquoise Interior",
    category: "interior"
  },
  {
    id: 9,
    url: "/images/gallery9.jpg",
    alt: "Luxury Rear Seats - Two-Tone Leather Detail",
    category: "interior"
  },
  {
    id: 11,
    url: "/images/gallery11.jpg",
    alt: "AMG Interior - Red Stitch Leather Detail",
    category: "interior"
  },
  {
    id: 10,
    url: "/images/gallery10.jpg",
    alt: "Off-Road Truck - Snow Foam Wash",
    category: "snow-foam"
  },
  {
    id: 12,
    url: "/images/gallery12.jpg",
    alt: "Range Rover - Glossy Black Exterior Finish",
    category: "exterior"
  },
  {
    id: 13,
    url: "/images/gallery13.jpg",
    alt: "Toyota Kluger - Interior Cabin Detail",
    category: "interior"
  },
  {
    id: 14,
    url: "/images/gallery14.jpg",
    alt: "Toyota Highlander - Foam Wash",
    category: "snow-foam"
  },
  {
    id: 16,
    url: "/images/gallery16.jpg",
    alt: "VW Amarok - Foam Pre-Wash",
    category: "snow-foam"
  },
  {
    id: 15,
    url: "/images/gallery15.jpg",
    alt: "Toyota Highlander - Polished Black Exterior",
    category: "exterior"
  },
  {
    id: 17,
    url: "/images/gallery17.jpg",
    alt: "VW Amarok - Clean Exterior Finish",
    category: "exterior"
  }
];

export const features = [
  {
    id: 1,
    title: "Fully Mobile",
    description: "We Come To You"
  },
  {
    id: 2,
    title: "Quality Products",
    description: "Safe for your vehicle"
  },
  {
    id: 3,
    title: "Save Time",
    description: "We come to you"
  },
  {
    id: 4,
    title: "Satisfaction Guaranteed",
    description: "100% guaranteed"
  }
];

// Mock booking submissions
export const mockBookings = [];

export const submitBooking = (bookingData) => {
  const booking = {
    id: Date.now(),
    ...bookingData,
    status: "pending",
    createdAt: new Date().toISOString()
  };
  mockBookings.push(booking);
  console.log("Booking submitted (MOCK):", booking);
  return booking;
};
